{
  "Full name": "ФИО",
  "Password": "Пароль",
  "Invitations": "Приглашения",
  "Welcome": "Добро пожаловать",
  "Have an account?": "Есть аккаунт?",
  "Change language": "Поменять язык",
  "Settings": "Настройки",
  "Log out": "Выйти",
  "Sign in": "Войти",
  "Sign up": "Зарегистрироваться",
  "auth/invalid-credential": "Недействительные учетные данные",
  "auth/user-not-found": "Пользователь не найден",
  "auth/wrong-password": "Неверная почта или пароль",
  "auth/email-already-in-use": "Этот адрес электронной почты уже используется",
  "auth/weak-password": "Слабый пароль",
  "auth/too-many-requests": "Слишком много запросов. Повторите позже",
  "auth/invalid-email": "Недействительный адрес электронной почты",
  "auth/user-disabled": "Аккаунт пользователя отключен",
  "auth/requires-recent-login": "Для выполнения этого действия требуется повторный вход в аккаунт",
  "auth/network-request-failed": "Ошибка сетевого запроса",
  "auth/operation-not-allowed": "Операция не разрешена",
  "auth/account-exists-with-different-credential": "Аккаунт уже существует с другими учетными данными",
  "Theme": "Тема",
  "Employees": "Работники",
  "Add new employee": "Добавить нового сотрудника",
  "Add": "Добавить",
  "Edit": "Редактировать",
  "Delete": "Удалить",
  "Invite": "Пригласить",
  "BoardScreen": "Технические заявки",
  "BoardScreenAdmin": "Технические заявки",
  "BoardScreenExecutor": "Технические заявки",
  "InventoryScreen": "Инвентарь",
  "RentalsScreen": "Аренды",
  "RentalPointsScreen": "Пункты аренды",
  "ClientsScreen": "Клиенты",
  "ChatScreen": "Чат",
  "WarehouseScreen": "Склад",
  "Ready for rent": "Готово к аренде",
  "Ready for issue": "Готово к выдаче",
  "To be decommissioned": "Под списание",
  "Functional": "Исправное",
  "Needs repair": "Требует ремонта",
  "Faulty": "Неисправное",
  "Under inspection": "На проверке",
  "Accepted after rent": "Принято после аренды",
  "Tool name": "Название инструмента",
  "Description": "Описание",
  "Visible For Others At": "Показать остальным с",
  "Undelivered comment": "Почему не доставили",
  "Price": "Цена",
  "SKU": "Артикул",
  "Inventory number": "Инв. номер",
  "Rental point": "Пункт проката",
  "Status": "Статус",
  "Category": "Категория",
  "Deposit amount": "Сумма депозита",
  "Purchase price": "Стоимость покупки",
  "Source of Acquisition": "Источник привлечения",
  "IIN": "ИИН",
  "Forgot password?": "Забыли пароль?",
  "Forgot password": "Восстановление пароля",
  "Restore": "Восстановить",
  "Enter your email": "Введите ваш email",
  "Create company": "Создать компанию",
  "Select": "Выбрать",
  "Company": "Компания",
  "Save": "Сохранить",
  "Company name": "Название компании",
  "Company type": "Тип компании",
  "Rent": "Аренда",
  "Chat": "Чат",
  "Select company": "Выбрать компанию",
  "Send": "Отправить",
  "Name": "Название",
  "Created By": "Создатель",
  "Channel": "Канал",
  "Branch": "Филиал",
  "open": "Открыт",
  "inProgress": "В прогрессе",
  "resolved": "Закрыт",
  "Requests": "Запросы",
  "Create new company": "Создать новую компанию",
  "List": "Список",
  "Board": "Доска",
  "ID": "Номер",
  "Assignee": "Исполнитель",
  "Email": "Электронная почта",
  "User role": "Роль пользователя",
  "Role": "Роль",
  "Asker": "Запрашивающий",
  "Responder": "Отвечающий",
  "Admin": "Администратор",
  "asker": "Запрашивающий",
  "responder": "Отвечающий",
  "admin": "Администратор",
  "ChatDrawerScreen": "Чаты",
  "Select role": "Выбрать роль",
  "Confirm Password": "Подтвердите пароль",
  "Chats": "Чаты",
  "Topic": "Канал",
  "Table": "Таблица",
  "Rows per page": "Строк на странице",
  "TicketsScreen": "Заявки",
  "Submit": "Подтвердить",
  "FormScreen": "Форма ввода",
  "DetailsScreen": "Детали",
  "CollectionPickerScreen": "Выбор",
  "Channels": "Каналы",
  "BranchesScreen": "Филиалы",
  "TypeScreen": "Типы проблем",
  "Issue type": "Тип проблемы",
  "PENDING": "Ожидает",
  "ACCEPTED": "Принят",
  "Submit2": "Сохранить",
  "Accept": "Қабылдау",
  "Decline": "Өшіру",
  "Join to company": "Присоединиться в компанию",
  "alertTitle": "Внимание",
  "deleteConfirmation": "Вы уверены, что хотите удалить?",
  "cancel": "Отмена",
  "confirmDelete": "Да",
  "Members": "Участники",
  "Invalid email address": "Неправильный формат почты",
  "Role is required": "Выберите роль",
  "Name is required": "Название обязательно",
  "Phone number must start with +7 and contain 10 digits after it": "Номер телефона должен начинаться с +7 и содержать 10 цифр после него",
  "Field is required": "Поле обязательно для заполнения",
  "Must be a valid number": "Должно быть числом",
  "Must select at least one option": "Необходимо выбрать хотя бы один вариант",
  "An unexpected error occurred. Please try again.": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова.",
  "Services": "Услуги",
  "Additional services": "Дополнительные услуги",
  "CustomersApplications": "Заявки",
  "CustomersApplicationsEmployee": "Заявки",
  "CustomersApplicationsAdmin": "Заявки",
  "CustomersApplicationsExecutor": "Заявки",
  "Shops": "Магазины",
  "Service name": "Название услуги",
  "Installation Type": "Тип установки",
  "Conditioner": "Кондиционер",
  "Large household appliances": "Крупная бытовая техника",
  "Technician visit": "Технический визит",
  "Service price": "Цена услуги",
  "Service description": "Описание услуги",
  "Client should have": "Клиент должен докупить самостоятельно",
  "Executor should have": "Исполнитель должен принести с собой",
  "Accessed to": "Доступ к следующим магазинам",
  "Additional service name": "Наименование услуги",
  "Measurement unit": "Единица измерения",
  "Buyer Name": "ФИО покупателя",
  "Address": "Адрес",
  "Seller Name": "ФИО продавца",
  "Shop branch": "Филиал магазина",
  "Contact Name": "Название контакта",
  "Installation date": "Дата установки",
  "Additional Services": "Дополнительные сервисы",
  "Phone Number": "Номер телефона",
  "KKM Receipt Number": "Номер чек ККМ",
  "Notes": "Примечания",
  "Add files": "Прикрепить файлы",
  "By cash": "Наличными",
  "Executor": "Исполнитель",
  "Total Price": "Общая цена",
  "Shop": "Магазин",
  "Branches": "Филиалы",
  "Branch name": "Название филиала",
  "Branch address": "Адрес филиала",
  "Files": "Файлы",
  "Incoming": "Исходящий",
  "Accepted": "Принято",
  "In progress": "В процессе",
  "Completed": "Завершено",
  "Uncompleted": "Незавершено",
  "shopEmployee": "Сотрудник магазина",
  "Users": "Пользователи",
  "executor": "Технический исполнитель",
  "operator": "Оператор",
  "lawyer": "Юрист",
  "courier": "Курьер",
  "customer": "Клиент",
  "sender": "Отправитель",
  "senderName": "Отправитель",
  "fullName": "ФИО",
  "Intech shop": "Intech магазин",
  "defaultRole": "Не назначена",
  "normal": "Обычный",
  "urgent": "Срочный",
  "after_19": "После 19:00",
  "DeliveryBoardScreen": "Доска доставок",
  "LawyerBoardScreen": "Заявки юристов",
  "MyDeliveryRequestsScreen": "Мои заявки на доставку",
  "DeliveryZoneMemoryScreen": "Память зон доставки",
  "DeliveryZonesScreen": "Зоны доставки",
  "DeliveryStreetsScreen": "Улицы доставки",
  "DeliveryCustomersScreen": "Клиенты доставки",
  "DeliveryNotificationsScreen": "Уведомления доставки",
  "DeliveryParserScreen": "Импорт доставок",
  "Reports": "Отчеты",
  "STOReportsScreen": "Отчеты СТО",
  "WeeklyReportsList": "Еженедельные отчеты",
  "NewEmployeeForm": "Форма нового сотрудника",
  "list": "Список",
  "form": "Форма",
  "chat": "Чат",
  "board": "Доска",
  "reports": "Отчеты",
  "RepairOrdersBoard": "Доска заказов на ремонт",
  "RepairOrdersList": "Список заказов на ремонт",
  "MechanicsList": "Список механиков",
  "CustomersList": "Список клиентов",
  "VehiclesList": "Список транспортных средств",
  "ServicesList": "Список услуг",
  "InventoryList": "Список инвентаря",
  "CustomerChat": "Чат с клиентами",
  "Vehicle": "Авто",
  "Order Number": "П/Н",
  "Mechanic": "Механик",
  "Payment Method": "Тип Оплаты",
  "Parts": "Запчасти",
  "Full Name": "Полное имя",
  "mechanic": "Механик",
  "electrician": "Электрик",
  "Roles": "Роли",
  "Diagnosis": "Неисправность",
  "Make": "Марка",
  "Model": "Модель",
  "Year": "Год",
  "VIN": "VIN",
  "License Plate": "Номерной знак",
  "Owner": "Владелец",
  "Service Name": "Название услуги",
  "Duration (hours)": "Длительность (часы)",
  "Part Name": "Название запчасти",
  "Quantity in Stock": "Количество на складе",
  "Storage Location": "Место хранения",
  "Diagnosed": "Диагностировано",
  "Waiting for Parts": "Ожидание запчастей",
  "Ready for Pickup": "Готово к выдаче",
  "Cancelled": "Отменено",
  "cash": "Наличные",
  "halyk": "Halyk",
  "kaspi": "Kaspi",
  "Add new": "Добавить",
  "Nothing found": "Ничего не найдено",
  "Works": "Работы",
  "paymentType": "Тип оплаты",
  "paymentAmount": "Сумма",
  "Remaining Amount": "Оставшаяся сумма",
  "Payment Methods": "Способы оплаты",
  "Payments": "Платежи",
  "wheelAlignment": "Развал-схождение",
  "engineMechanic": "Моторист",
  "tireService": "Шиномонтаж",
  "generator_starter": "Генератор стартер",
  "starter": "Стартер",
  "All": "Все",
  "Period": "Период",
  "Export CSV": "Выгрузить CSV",
  "No data": "Нет данных",
  "No records to export": "Нет записей для выгрузки",
  "Failed to export CSV": "Не удалось выгрузить CSV",
  "month": "По месяцам",
  "quarter": "За квартал",
  "year": "За год",
  "range": "За период",
  "Department": "Отдел",
  "Task Type": "Тип задачи",
  "hotel-tasks": "Технические",
  "cleaning-tasks": "Клининг",
  "Task description": "Описание задачи",
  "technical": "техническая",
  "one time": "разовая",
  "in progress": "в прогрессе",
  "legal_in_work": "В работе",
  "legal_new": "Новое",
  "Tasks": "Задачи",
  "in review": "на проверке",
  "legal_completed": "Окончено",
  "Deadline": "Срок",
  "Note": "Заметка",
  "Block": "Блок",
  "Attachments": "Вложения",
  "blocked": "в блоке",
  "dateCreated": "Дата создания",
  "dateUpdated": "Время изменения",
  "Mechanics": "Механики",
  "First Name": "Имя",
  "Last Name": "Фамилия",
  "Birthday": "Дата рождения",
  "cleaning": "Клининг",
  "Appearance": "Внешний вид",
  "Switch between light and dark mode": "Переключение между светлой и темной темой",
  "Language": "Язык",
  "Select your preferred language": "Выберите предпочитаемый язык",
  "Profile Information": "Информация профиля",
  "Avatar": "Аватар",
  "Change name": "Изменить имя",
  "First name": "Имя",
  "Last name": "Фамилия",
  "Cancel": "Отмена",
  "by car number": "Поиск по номеру машины",
  "Notifications": "Уведомления",
  "Display mode": "Вид приложения",
  "granted": "Разрешены",
  "denied": "Отключены",
  "default": "Отключены",
  "standalone": "PWA",
  "browser": "Браузер",
  "ExpensesList": "Расходы",
  "Amount": "Сумма",
  "Date": "Дата",
  "MakesList": "Список марок",
  "ModelsList": "Список моделей",
  "Subscriptions": "Абонементы",
  "Payment": "Оплата",
  "Subscription": "Абонемент",
  "Valid Until": "Действует До",
  "Remind": "Связь (напоминание)",
  "СВБ": "СВБ",
  "Дневной": "Дневной",
  "Безлимит": "Безлимит",
  "gym_manager": "Менеджер спортзала",
  "director": "Директор",
  "CleaningBoardScreen": "Клининг заявки",
  "ArchivedHotelTasksScreen": "Архивные заявки",
  "RecurringTasksScreen": "Плановые работы",
  "RecurringTaskTemplatesScreen": "Шаблоны повторяющихся заявок",
  "HotelReportsScreen": "Отчеты бизнес-центра",
  "TechWarehouseScreen": "Технический склад",
  "TechWarehouseReceiptsScreen": "Поступления тех. склада",
  "CleaningWarehouseScreen": "Склад клининга",
  "HotelTenantCompaniesScreen": "Компании-арендаторы",
  "HotelTenantEmployeesScreen": "Сотрудники арендаторов",
  "cleaning_manager": "Менеджер клининга",
  "cleaning_executor": "Исполнитель клининга",
  "WarehouseScreen": "Склад",
  "warehouse": "Склад",
  "Наименование товара": "Наименование товара",
  "Количество": "Количество",
  "Описание": "Описание",
  "Расположение": "Расположение",
  "Дата создания": "Дата создания",
  "FurnitureCraft Pro": "МебельCraft Pro",
  "Furniture": "Мебель",
  "OrdersBoard": "Доска заказов",
  "ProductsList": "Список товаров",
  "MaterialsList": "Список материалов",
  "DesignsList": "Список дизайнов",
  "FurnitureReportsScreen": "Отчеты по мебели",
  "furniture-orders": "заказы-мебель",
  "customers": "клиенты",
  "furniture-products": "товары-мебель",
  "materials": "материалы",
  "inventory": "инвентарь",
  "furniture-designs": "дизайны-мебель",
  "Order #": "Заказ №",
  "Customer": "Клиент",
  "Furniture Items": "Мебельные изделия",
  "Custom Design": "Индивидуальный дизайн",
  "Materials": "Материалы",
  "Labor Cost": "Стоимость работ",
  "Delivery Date": "Дата доставки",
  "Delivery Address": "Адрес доставки",
  "Write in WhatsApp": "Написать в WhatsApp",
  "Special Instructions": "Особые указания",
  "Assigned Craftsman": "Назначенный мастер",
  "Assigned Designer": "Назначенный дизайнер",
  "Date Created": "Дата создания",
  "Submission Date": "Дата",
  "Initiator Full Name": "Инициатор",
  "Contract Name": "Договор",
  "Type of Goods/Works/Services": "Вид",
  "legal_goods": "Товар",
  "legal_works": "Работы",
  "legal_services": "Услуги",
  "Delivery / Execution Terms": "Сроки",
  "Contract Amount": "Сумма",
  "VAT Type": "НДС",
  "legal_with_vat": "С НДС",
  "legal_without_vat": "Без НДС",
  "Payment Procedure": "Порядок оплаты",
  "legal_prepayment": "Предоплата",
  "legal_postpayment": "По факту",
  "Contractor Name": "Исполнитель",
  "Contractor Contacts": "Контакты",
  "Commercial Proposal": "Коммерческое предложение",
  "Comments": "Комментарии",
  "Archived": "Архивировано",
  "Full Name": "Полное имя",
  "Tenant company": "Компания-арендатор",
  "Position": "Должность",
  "Phone Number": "Номер телефона",
  "Email": "Электронная почта",
  "Address": "Адрес",
  "Preferred Contact": "Предпочтительная связь",
  "Customer Notes": "Заметки клиента",
  "Product Name": "Название товара",
  "Type": "Тип",
  "Base Price": "Базовая цена",
  "Dimensions (L x W x H)": "Размеры (Д x Ш x В)",
  "Primary Material": "Основной материал",
  "Production Time (days)": "Время производства (дни)",
  "Customizable": "Настраиваемый",
  "Product Image": "Изображение товара",
  "Material Name": "Название материала",
  "Material Type": "Тип материала",
  "Price per Unit": "Цена за единицу",
  "Unit": "Единица",
  "Supplier": "Поставщик",
  "Color": "Цвет",
  "Item Name": "Название предмета",
  "Minimum Stock Level": "Минимальный уровень запаса",
  "Last Restocked": "Последнее пополнение",
  "Design Name": "Название дизайна",
  "Designer": "Дизайнер",
  "Design Files": "Файлы дизайна",
  "Template Design": "Шаблонный дизайн",
  "Phone": "Телефон",
  "Specialization": "Специализация",
  "Living Room": "Гостиная",
  "Bedroom": "Спальня",
  "Dining Room": "Столовая",
  "Kitchen": "Кухня",
  "Office": "Офис",
  "Outdoor": "Уличная",
  "Custom": "Индивидуальная",
  "Chair": "Стул",
  "Sofa": "Диван",
  "Bed": "Кровать",
  "Cabinet": "Шкаф",
  "Bookshelf": "Книжная полка",
  "Desk": "Рабочий стол",
  "Dresser": "Комод",
  "Dining Set": "Столовый набор",
  "Coffee Table": "Журнальный столик",
  "Wardrobe": "Гардероб",
  "Oak": "Дуб",
  "Maple": "Клен",
  "Cherry": "Вишня",
  "Walnut": "Орех",
  "Pine": "Сосна",
  "Mahogany": "Красное дерево",
  "Birch": "Береза",
  "Ash": "Ясень",
  "MDF": "МДФ",
  "Plywood": "Фанера",
  "Glass": "Стекло",
  "Metal": "Металл",
  "Fabric": "Ткань",
  "Leather": "Кожа",
  "piece": "штука",
  "meter": "метр",
  "square_meter": "квадратный метр",
  "cubic_meter": "кубический метр",
  "kg": "кг",
  "liter": "литр",
  "bank_transfer": "Банковский перевод",
  "credit_card": "Кредитная карта",
  "installment": "Рассрочка",
  "quote_requested": "Запрошена цена",
  "quote_sent": "Цена отправлена",
  "order_confirmed": "Заказ подтвержден",
  "design_phase": "Фаза дизайна",
  "production_phase": "Фаза производства",
  "quality_check": "Проверка качества",
  "ready_for_delivery": "Готово к доставке",
  "delivered": "Доставлено",
  "completed": "Завершено",
  "cancelled": "Отменено",
  "designer": "Дизайнер",
  "craftsman": "Мастер",
  "manager": "Технический менеджер",
  "sales": "Продажи",
  "customer_service": "Обслуживание клиентов",
  "quality_control": "Контроль качества",
  "FilesScreen": "Файлы",
  "File name": "Имя файла",
  "File": "Файл",
  "Photo": "Фото",
  "Added by": "Добавлено",
  "Date added": "Дата добавления",
  "Download": "Скачать",
  "Frequency": "Частота",
  "Activity": "Активность",
  "No activity yet": "Пока нет активности",
  "cardLog.statusMoved": "{{user}} переместил(а) эту карточку: из \"{{from}}\" в \"{{to}}\"",
  "cardLog.updated": "{{user}} обновил(а) карточку",
  "daily": "Ежедневно",
  "weekly": "Еженедельно",
  "monthly": "Ежемесячно",
  "annual": "Ежегодно",
  "chatField": {
    "loadingMessages": "Загрузка сообщений...",
    "noMessages": "Сообщений пока нет. Нажмите, чтобы начать чат."
  },
  "Create": "Создать",
  "Create Folder": "Создать папку",
  "Create New Folder": "Создать новую папку",
  "Delete File": "Удалить файл",
  "Delete Folder": "Удалить папку",
  "Are you sure you want to delete this file?": "Вы уверены, что хотите удалить этот файл?",
  "Are you sure you want to delete this folder?": "Вы уверены, что хотите удалить эту папку?",
  "File Details": "Детали файла",
  "Actions": "Действия",
  "File metadata": "Метаданные файла",
  "Kind": "Тип",
  "Updated": "Обновлено",
  "Share": "Поделиться",
  "Properties": "Свойства",
  "Rename": "Переименовать",
  "Save to device storage": "Сохранить на устройство",
  "Send to others or apps": "Отправить другим или в приложения",
  "File not found": "Файл не найден",
  "This file is no longer available.": "Этот файл больше недоступен.",
  "Failed to download file. Please try again.": "Не удалось открыть файл. Попробуйте еще раз.",
  "Image": "Изображение",
  "Video": "Видео",
  "Audio": "Аудио",
  "PDF Document": "PDF-документ",
  "Word Document": "Документ Word",
  "Spreadsheet": "Таблица",
  "Presentation": "Презентация",
  "Archive": "Архив",
  "Modified unknown": "Изменено: неизвестно",
  "Modified just now": "Изменено только что",
  "Modified yesterday": "Изменено вчера",
  "Modified {{count}} hours ago": "Изменено {{count}} ч. назад",
  "Modified {{count}} days ago": "Изменено {{count}} дн. назад",
  "Modified {{value}}": "Изменено {{value}}",
  "Rename Folder": "Переименовать папку",
  "Folder Name": "Название папки",
  "Upload File": "Загрузить файл",
  "Search in Drive": "Поиск в Файлах",
  "Folders": "Папки",
  "Recent Files": "Недавние файлы",
  "Enter your email.": "Введите ваш email.",
  "Password reset link sent to your email.": "Ссылка для сброса пароля отправлена на вашу почту.",
  "Failed to send password reset link. Please check your email and try again.": "Не удалось отправить ссылку для сброса пароля. Проверьте email и попробуйте снова.",
  "Today": "Сегодня",
  "Count": "Количество",
  "Avg Time (hours)": "Среднее время (часы)",
  "generator": "Генератор",
  "No company selected": "Компания не выбрана",
  "Request sent": "Запрос отправлен",
  "Enter company name!": "Введите название компании!",
  "Select company type!": "Выберите тип компании!",
  "Invited successfully!": "Приглашение отправлено!",
  "Access denied": "Доступ запрещён",
  "Gallery permission is required": "Необходимо разрешить доступ к галерее",
  "Upload error": "Ошибка загрузки",
  "Failed to upload media file.": "Не удалось загрузить медиафайл.",
  "An error occurred": "Произошла ошибка",
  "Failed to pick file": "Произошла ошибка при выборе файла",
  "This file type is not supported on your device": "Этот тип файла не поддерживается на вашем устройстве",
  "Failed to open file": "Не удалось открыть файл",
  "Error": "Ошибка",
  "OK": "ОК",
  "Confirm": "Подтвердить",
  "Add checklist": "Добавить чек-лист",
  "Add item": "Добавить пункт",
  "Administration": "Администрирование",
  "App Updates": "Обновления приложения",
  "Are you sure you want to delete this employee? This action cannot be undone.": "Вы уверены, что хотите удалить этого сотрудника? Это действие нельзя отменить.",
  "Audio File": "Аудиофайл",
  "Audio playback error": "Ошибка воспроизведения аудио",
  "Authentication failed": "Ошибка аутентификации",
  "Configuration Management": "Управление конфигурацией",
  "Create Rent": "Создать аренду",
  "Delete Employee": "Удалить сотрудника",
  "Edit Profile": "Редактировать профиль",
  "EmployeeDetailsScreen": "Данные сотрудника",
  "employees": "сотрудников",
  "Employees will appear here once they join": "Сотрудники появятся здесь после присоединения",
  "Failed to delete employee. Please try again.": "Не удалось удалить сотрудника. Попробуйте снова.",
  "Failed to share file": "Не удалось отправить файл",
  "Hide password": "Скрыть пароль",
  "Loading employees...": "Загрузка сотрудников...",
  "Manage app configurations": "Управление конфигурациями приложения",
  "Media": "Медиа",
  "No employees found": "Сотрудники не найдены",
  "No employees yet": "Сотрудников пока нет",
  "Pending Invitations": "Ожидающие приглашения",
  "Last login by platform": "Последний вход по платформам",
  "Sharing is not available on this device": "Отправка недоступна на этом устройстве",
  "Show password": "Показать пароль",
  "Signature": "Подпись",
  "Team Members": "Участники команды",
  "Try adjusting your search terms": "Попробуйте изменить поисковый запрос",
  "Unknown file type": "Неизвестный тип файла",
  "Video playback error": "Ошибка воспроизведения видео",
  "Video source error": "Ошибка источника видео",
  "Update Available": "Доступно обновление",
  "A new version ({{version}}) is available. Would you like to update now?": "Доступна новая версия ({{version}}). Обновить сейчас?",
  "Later": "Позже",
  "Update": "Обновить",
  "Permission Granted": "Разрешение получено",
  "You'll now receive important notifications from the app!": "Теперь вы будете получать важные уведомления от приложения!",
  "Great!": "Отлично!",
  "Permission Denied": "Разрешение отклонено",
  "To enable notifications, go to Settings > Apps > Tizim > Notifications and turn them on.": "Чтобы включить уведомления, перейдите в Настройки > Приложения > Tizim > Уведомления и включите их.",
  "Open Settings": "Открыть настройки",
  "You can enable notifications in Settings > Notifications > Tizim": "Вы можете включить уведомления в Настройки > Уведомления > Tizim",
  "Failed to request notification permission. Please try again.": "Не удалось запросить разрешение на уведомления. Попробуйте снова.",
  "Notifications are disabled": "Уведомления отключены",
  "Notifications not set up": "Уведомления не настроены",
  "Error checking permissions": "Ошибка проверки разрешений",
  "Enable notifications": "Включите уведомления",
  "Requesting...": "Запрос...",
  "Enable in Settings": "Включить в настройках",
  "Enable Notifications": "Включить уведомления",
  "Stay Updated": "Оставайтесь в курсе",
  "Enable notifications to receive important updates, messages, and alerts from the app.": "Включите уведомления, чтобы получать важные обновления, сообщения и оповещения от приложения.",
  "Apply Update": "Применить обновление",
  "This will restart the app to apply the update. Continue?": "Приложение будет перезапущено для применения обновления. Продолжить?",
  "Apply": "Применить",
  "Version": "Версия",
  "New version": "Новая версия",
  "Applying...": "Применение...",
  "Development Mode": "Режим разработки",
  "Updates are simulated in development builds. Build a preview/production app to test real updates.": "В dev-сборках обновления эмулируются. Соберите preview/production-версию, чтобы проверить реальные обновления.",
  "Runtime": "Рантайм",
  "Checking...": "Проверка...",
  "Check": "Проверить",
  "View All": "Показать все",
  "Yes": "Да",
  "No": "Нет",
  "Менеджер связался": "Менеджер связался",
  "Street": "Улица",
  "House Number": "Номер дома",
  "Apartment": "Квартира",
  "At Home": "Дома",
  "Not At Home": "Не дома",
  "Not Contacted": "Не связался",
  "new": "Новая",
  "not_delivered": "Не доставлено",
  "normal": "Обычный",
  "urgent": "Срочно",
  "after_19": "После 19:00",
  "По дате": "По дате",
  "Келу күні": "Дата поступления",
  "Заттар": "Товары",
  "Қабылдаған": "Принял",
  "Ескертпе": "Примечание"
}
